// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Signup.css */

.signup-page {
  min-height: 100vh;
  background: var(--bg-gradient);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.signup-container {
  width: 100%;
  max-width: 520px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 20px;
  box-shadow: var(--shadow-xl);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  overflow: hidden;
  animation: fadeInUp 0.6s ease-out;
}

[data-theme="dark"] .signup-container {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);
}

/* Header Section */
.signup-header {
  text-align: center;
  padding: 40px 32px 32px 32px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-primary);
}

.logo-container {
  width: 56px;
  height: 56px;
  background: var(--accent-gradient);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  box-shadow: var(--shadow-md);
}

.logo-icon {
  width: 28px;
  height: 28px;
  color: #FFFFFF;
}

.signup-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.signup-subtitle {
  font-size: 16px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}

/* Form Container */
.signup-form-container {
  padding: 32px;
}

.signup-form {
  margin-bottom: 24px;
}

/* Form Groups and Rows */
.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}

.form-row .form-group {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.optional {
  font-weight: 400;
  color: var(--text-tertiary);
  font-size: 13px;
}

/* Input Container */
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  width: 16px;
  height: 16px;
  color: var(--text-tertiary);
  z-index: 1;
  transition: color 0.2s ease;
}

.form-input,
.form-select {
  width: 100%;
  padding: 16px 16px 16px 48px;
  border: 1px solid var(--border-secondary);
  border-radius: 12px;
  background: var(--input-bg);
  color: var(--text-primary);
  font-size: 16px;
  transition: all 0.2s ease;
  outline: none;
}

.form-input::placeholder {
  color: var(--text-tertiary);
}

.form-select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 48px;
}

[data-theme="dark"] .form-select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%9ca3af' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
}

.form-input:focus,
.form-select:focus {
  border-color: var(--accent-primary);
  box-shadow: var(--input-focus-shadow);
}

.form-input:focus + .input-icon,
.form-select:focus + .input-icon,
.input-container:focus-within .input-icon {
  color: var(--accent-primary);
}

.form-input.error,
.form-select.error {
  border-color: var(--error-text);
  background: var(--error-bg);
}

/* Password Toggle */
.password-toggle {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.password-toggle:hover {
  color: var(--text-primary);
  background: var(--bg-secondary);
}

/* Terms Section */
.terms-section {
  margin-bottom: 24px;
  padding: 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
}

.terms-text {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
  text-align: center;
}

/* Error Messages */
.error-message {
  display: block;
  color: var(--error-text);
  font-size: 13px;
  margin-top: 6px;
  font-weight: 500;
}

.submit-error {
  background: var(--error-bg);
  border: 1px solid var(--error-border);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: var(--error-text);
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

/* Submit Button */
.submit-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--accent-gradient);
  color: #FFFFFF;
  border: none;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
  margin-bottom: 24px;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.submit-btn.loading {
  pointer-events: none;
}

/* Loading Spinner */
.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #FFFFFF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Divider */
.divider {
  position: relative;
  text-align: center;
  margin: 24px 0;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border-secondary);
}

.divider span {
  background: var(--bg-primary);
  color: var(--text-tertiary);
  font-size: 13px;
  font-weight: 500;
  padding: 0 16px;
  position: relative;
  z-index: 1;
}

/* Social Signup */
.social-signup {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.google-btn,
.phone-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 20px;
  border: 1px solid var(--border-secondary);
  border-radius: 12px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.google-btn:hover:not(:disabled),
.phone-btn:hover:not(:disabled) {
  border-color: var(--border-primary);
  background: var(--bg-secondary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.google-btn:disabled,
.phone-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.google-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Footer */
.signup-footer {
  text-align: center;
  padding: 24px 32px 32px 32px;
  border-top: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.signup-footer p {
  color: var(--text-secondary);
  font-size: 14px;
  margin: 0;
}

.link-btn {
  background: none;
  border: none;
  color: var(--accent-primary);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 0.2s ease;
}

.link-btn:hover {
  color: var(--accent-secondary);
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .signup-page {
    padding: 16px 12px;
  }
  
  .signup-container {
    max-width: 100%;
    border-radius: 16px;
  }
  
  .signup-header {
    padding: 32px 24px 24px 24px;
  }
  
  .signup-title {
    font-size: 24px;
  }
  
  .signup-subtitle {
    font-size: 15px;
  }
  
  .signup-form-container {
    padding: 24px;
  }
  
  /* Stack form rows on mobile */
  .form-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .form-row .form-group {
    margin-bottom: 0;
  }
  
  .form-input,
  .form-select {
    font-size: 16px; /* Prevents zoom on iOS */
    padding: 14px 14px 14px 44px;
  }
  
  .submit-btn {
    padding: 14px 20px;
    font-size: 15px;
  }
  
  .google-btn,
  .phone-btn {
    padding: 12px 16px;
    font-size: 14px;
  }
  
  .signup-footer {
    padding: 20px 24px 24px 24px;
  }
  
  .terms-section {
    padding: 14px;
  }
  
  .terms-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .signup-container {
    max-width: 100%;
  }
  
  .form-row {
    gap: 16px;
  }
  
  .form-input,
  .form-select {
    padding: 12px 12px 12px 40px;
  }
  
  .input-icon {
    left: 14px;
    width: 14px;
    height: 14px;
  }
  
  .password-toggle {
    right: 14px;
  }
}

/* Focus and Accessibility */
.submit-btn:focus-visible,
.google-btn:focus-visible,
.phone-btn:focus-visible,
.link-btn:focus-visible,
.password-toggle:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

.form-input:focus-visible,
.form-select:focus-visible {
  outline: none; /* Handled by border and shadow */
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .signup-container {
    border-width: 2px;
  }
  
  .form-input,
  .form-select {
    border-width: 2px;
  }
  
  .submit-btn {
    border: 2px solid var(--accent-primary);
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .signup-container,
  .submit-btn,
  .google-btn,
  .phone-btn,
  .form-input,
  .form-select,
  .password-toggle,
  .link-btn {
    transition: none;
  }
  
  .loading-spinner {
    animation: none;
  }
  
  .fadeInUp {
    animation: none;
  }
}

/* Password Strength Indicator (Optional Enhancement) */
.password-strength {
  margin-top: 8px;
  display: flex;
  gap: 4px;
}

.strength-bar {
  height: 3px;
  flex: 1 1;
  background: var(--border-tertiary);
  border-radius: 2px;
  transition: background-color 0.2s ease;
}

.strength-bar.weak {
  background: #EF4444;
}

.strength-bar.medium {
  background: #F59E0B;
}

.strength-bar.strong {
  background: #10B981;
}

.strength-text {
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
}

.strength-text.weak {
  color: #EF4444;
}

.strength-text.medium {
  color: #F59E0B;
}

.strength-text.strong {
  color: #10B981;
}`, "",{"version":3,"sources":["webpack://./src/styles/Signup.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;AAClD;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iPAAiP;AACnP;;AAEA;;EAEE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kCAAkC;EAClC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe,EAAE,yBAAyB;IAC1C,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;;;;;EAKE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;;EAEE,aAAa,EAAE,iCAAiC;AAClD;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;;;;;IAQE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAO;EACP,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Signup.css */\n\n.signup-page {\n  min-height: 100vh;\n  background: var(--bg-gradient);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n}\n\n.signup-container {\n  width: 100%;\n  max-width: 520px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 20px;\n  box-shadow: var(--shadow-xl);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  overflow: hidden;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n[data-theme=\"dark\"] .signup-container {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);\n}\n\n/* Header Section */\n.signup-header {\n  text-align: center;\n  padding: 40px 32px 32px 32px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.logo-container {\n  width: 56px;\n  height: 56px;\n  background: var(--accent-gradient);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px auto;\n  box-shadow: var(--shadow-md);\n}\n\n.logo-icon {\n  width: 28px;\n  height: 28px;\n  color: #FFFFFF;\n}\n\n.signup-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.signup-subtitle {\n  font-size: 16px;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Form Container */\n.signup-form-container {\n  padding: 32px;\n}\n\n.signup-form {\n  margin-bottom: 24px;\n}\n\n/* Form Groups and Rows */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.form-row .form-group {\n  margin-bottom: 0;\n}\n\n.form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.optional {\n  font-weight: 400;\n  color: var(--text-tertiary);\n  font-size: 13px;\n}\n\n/* Input Container */\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 16px;\n  width: 16px;\n  height: 16px;\n  color: var(--text-tertiary);\n  z-index: 1;\n  transition: color 0.2s ease;\n}\n\n.form-input,\n.form-select {\n  width: 100%;\n  padding: 16px 16px 16px 48px;\n  border: 1px solid var(--border-secondary);\n  border-radius: 12px;\n  background: var(--input-bg);\n  color: var(--text-primary);\n  font-size: 16px;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.form-input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.form-select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  padding-right: 48px;\n}\n\n[data-theme=\"dark\"] .form-select {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%9ca3af' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n}\n\n.form-input:focus,\n.form-select:focus {\n  border-color: var(--accent-primary);\n  box-shadow: var(--input-focus-shadow);\n}\n\n.form-input:focus + .input-icon,\n.form-select:focus + .input-icon,\n.input-container:focus-within .input-icon {\n  color: var(--accent-primary);\n}\n\n.form-input.error,\n.form-select.error {\n  border-color: var(--error-text);\n  background: var(--error-bg);\n}\n\n/* Password Toggle */\n.password-toggle {\n  position: absolute;\n  right: 16px;\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.password-toggle:hover {\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n}\n\n/* Terms Section */\n.terms-section {\n  margin-bottom: 24px;\n  padding: 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n}\n\n.terms-text {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n  text-align: center;\n}\n\n/* Error Messages */\n.error-message {\n  display: block;\n  color: var(--error-text);\n  font-size: 13px;\n  margin-top: 6px;\n  font-weight: 500;\n}\n\n.submit-error {\n  background: var(--error-bg);\n  border: 1px solid var(--error-border);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  color: var(--error-text);\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* Submit Button */\n.submit-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--accent-gradient);\n  color: #FFFFFF;\n  border: none;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-md);\n  margin-bottom: 24px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.submit-btn.loading {\n  pointer-events: none;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid #FFFFFF;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Divider */\n.divider {\n  position: relative;\n  text-align: center;\n  margin: 24px 0;\n}\n\n.divider::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: var(--border-secondary);\n}\n\n.divider span {\n  background: var(--bg-primary);\n  color: var(--text-tertiary);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 0 16px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Social Signup */\n.social-signup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.google-btn,\n.phone-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 14px 20px;\n  border: 1px solid var(--border-secondary);\n  border-radius: 12px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.google-btn:hover:not(:disabled),\n.phone-btn:hover:not(:disabled) {\n  border-color: var(--border-primary);\n  background: var(--bg-secondary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.google-btn:disabled,\n.phone-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.google-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* Footer */\n.signup-footer {\n  text-align: center;\n  padding: 24px 32px 32px 32px;\n  border-top: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n}\n\n.signup-footer p {\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin: 0;\n}\n\n.link-btn {\n  background: none;\n  border: none;\n  color: var(--accent-primary);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  transition: color 0.2s ease;\n}\n\n.link-btn:hover {\n  color: var(--accent-secondary);\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 640px) {\n  .signup-page {\n    padding: 16px 12px;\n  }\n  \n  .signup-container {\n    max-width: 100%;\n    border-radius: 16px;\n  }\n  \n  .signup-header {\n    padding: 32px 24px 24px 24px;\n  }\n  \n  .signup-title {\n    font-size: 24px;\n  }\n  \n  .signup-subtitle {\n    font-size: 15px;\n  }\n  \n  .signup-form-container {\n    padding: 24px;\n  }\n  \n  /* Stack form rows on mobile */\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .form-row .form-group {\n    margin-bottom: 0;\n  }\n  \n  .form-input,\n  .form-select {\n    font-size: 16px; /* Prevents zoom on iOS */\n    padding: 14px 14px 14px 44px;\n  }\n  \n  .submit-btn {\n    padding: 14px 20px;\n    font-size: 15px;\n  }\n  \n  .google-btn,\n  .phone-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n  \n  .signup-footer {\n    padding: 20px 24px 24px 24px;\n  }\n  \n  .terms-section {\n    padding: 14px;\n  }\n  \n  .terms-text {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .signup-container {\n    max-width: 100%;\n  }\n  \n  .form-row {\n    gap: 16px;\n  }\n  \n  .form-input,\n  .form-select {\n    padding: 12px 12px 12px 40px;\n  }\n  \n  .input-icon {\n    left: 14px;\n    width: 14px;\n    height: 14px;\n  }\n  \n  .password-toggle {\n    right: 14px;\n  }\n}\n\n/* Focus and Accessibility */\n.submit-btn:focus-visible,\n.google-btn:focus-visible,\n.phone-btn:focus-visible,\n.link-btn:focus-visible,\n.password-toggle:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n.form-input:focus-visible,\n.form-select:focus-visible {\n  outline: none; /* Handled by border and shadow */\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .signup-container {\n    border-width: 2px;\n  }\n  \n  .form-input,\n  .form-select {\n    border-width: 2px;\n  }\n  \n  .submit-btn {\n    border: 2px solid var(--accent-primary);\n  }\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .signup-container,\n  .submit-btn,\n  .google-btn,\n  .phone-btn,\n  .form-input,\n  .form-select,\n  .password-toggle,\n  .link-btn {\n    transition: none;\n  }\n  \n  .loading-spinner {\n    animation: none;\n  }\n  \n  .fadeInUp {\n    animation: none;\n  }\n}\n\n/* Password Strength Indicator (Optional Enhancement) */\n.password-strength {\n  margin-top: 8px;\n  display: flex;\n  gap: 4px;\n}\n\n.strength-bar {\n  height: 3px;\n  flex: 1;\n  background: var(--border-tertiary);\n  border-radius: 2px;\n  transition: background-color 0.2s ease;\n}\n\n.strength-bar.weak {\n  background: #EF4444;\n}\n\n.strength-bar.medium {\n  background: #F59E0B;\n}\n\n.strength-bar.strong {\n  background: #10B981;\n}\n\n.strength-text {\n  font-size: 12px;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n.strength-text.weak {\n  color: #EF4444;\n}\n\n.strength-text.medium {\n  color: #F59E0B;\n}\n\n.strength-text.strong {\n  color: #10B981;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
